<template>
    <textarea class="form-control" ref="textarea"></textarea>
</template>
<script>
export default {
    name: 'html-wrapper',
    props: {
        value: String,
        htmlWarning: Boolean,
        mode: {
            type: String
        },
        height: {
            type: String,
            default: '150'
        },
    },
    mounted() {
        const vm = this;
        const initialValue = this.value;

        const config = {
            height: this.height,
            tooltip: false,
            toolbar: [],
            disableResizeEditor: true,
            callbacks: {
                onInit: function() {
                    $(vm.$refs.textarea).summernote("code", initialValue);
                },
                onChange: function() {
                    vm.$emit('handleHtml', $(vm.$refs.textarea).summernote('code'));
                },
                onCodeviewToggled: function() {
                    const codeviewActive = $(vm.$refs.textarea).summernote("codeview.isActivated");

                    vm.$emit('handleWarning', codeviewActive);
                }
            }
        };

        // add toolbar + settings if active mode
        if (this.mode === 'active') {
            config.disableResizeEditor = false;
            config.toolbar = [
                ['paragraphstyle', ['style', 'ul']],
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['insert', ['link']],
                ['view', ['codeview']]
            ];

            // TODO: clean this up - hacky solution to fix duplicate
            // active editors that appear in certain circumstances
            let editors = [...$(".active-mode .note-editor")];

            if (editors.length) {
                editors.forEach((instance) => {
                    instance.remove();
                });
            }
        }

        this.$nextTick(() => {
            $(this.$refs.textarea).summernote(config);
        })
    },
    watch: {
        value: function() {
            let currentLocalValue = $(this.$refs.textarea).summernote('code');

            // update if toggling modes and parent value differs from local
            if (this.value !== currentLocalValue) {
                $(this.$refs.textarea).summernote('code', this.value);
            }
        }
    }
}
</script>
